module.exports = __webpack_public_path__ + "static/ACP-Watermark-4f5e4386a5710c9ed8275af860163796.png";